import React from "react";
import { makeStyles, Box } from "@material-ui/core";
import HotelIcon from "../../assets/img/hotel.svg";
import PriceIcon from "../../assets/img/price.svg";
import ClockIcon from "../../assets/img/clock.svg";
import { blue, bordoLight, green } from "../../constants/colors";

const useStyles = makeStyles(({ breakpoints: { down } }) => ({
  badge: {
    backgroundColor: ({ value }) =>
      value === "hotel" ? bordoLight : value === "price" ? green : blue,
    borderRadius: "6px",
    color: "white",
    textTransform: "capitalize",
    padding: "5px 9px",
    "& p": {
      fontSize: "10px",
      fontWeight: "bold",
      margin: 0,
      lineHeight: 1.5,
    },
    "& img": {
      display: ({withLabel})=> withLabel ? 'block' : "none",
      marginRight:  ({withLabel})=> withLabel ? '2px' : '0',
    },
    [down("xs")]: {
      height: "20px",
      width: ({withLabel})=> withLabel ? '60px' : "20px",
      borderRadius: ({withLabel})=> withLabel ? '6px' : "50%",
      padding: 0,
      "& p": {
        display: ({withLabel})=> withLabel ? 'block' : 'none',
      },
      "& img": {
        display: "block !important",
        margin: "0",
        marginRight:  ({withLabel})=> withLabel ? '2px' : '0',
        maxWidth: ({withLabel})=> withLabel ? "13px" : "10px",
      },
    },
  },
}));

const FlightBadge = ({ info, withLabel }) => {
  const { value, label } = info;
  const { badge } = useStyles({ value, withLabel });

  const renderImg = (badge) => {
    if (badge === "hotel") {
      return <img src={HotelIcon} alt="badge" />;
    }
    if (badge === "price") {
      return <img src={PriceIcon} alt="badge" />;
    }
    return <img src={ClockIcon} alt="badge" />;
  };
  return (
    <Box
      className={badge}
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      {renderImg(value)}
      <p>{label}</p>
    </Box>
  );
};

export default FlightBadge;
